import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
import { cn } from "../cn.js";
const sizes = { sm: "size-3.5", md: "size-4", lg: "size-6" };
/** Indeterminate progress indicator. */
export function Spinner({ label, size = "md", className }) {
    const svg = (_jsxs("svg", { className: cn("animate-spin", sizes[size], className), viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", children: [_jsx("circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeOpacity: "0.25", strokeWidth: "3" }), _jsx("path", { d: "M21 12a9 9 0 0 0-9-9", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round" })] }));
    if (!label)
        return svg;
    return (_jsxs("span", { role: "status", className: "inline-flex items-center", children: [svg, _jsx("span", { className: "sr-only", children: label })] }));
}
//# sourceMappingURL=Spinner.js.map